<template>
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M51.3327 27.9998C51.3327 40.8865 40.886 51.3332 27.9994 51.3332C15.1127 51.3332 4.66602 40.8865 4.66602 27.9998C4.66602 15.1132 15.1127 4.6665 27.9994 4.6665C40.886 4.6665 51.3327 15.1132 51.3327 27.9998Z"
      stroke="var(--sf-base-icon-primary)"
      stroke-width="2"
    />
    <path
      d="M13.9993 27.9998C13.9993 25.4225 16.0887 23.3332 18.666 23.3332H37.3327C39.91 23.3332 41.9994 25.4225 41.9994 27.9998C41.9994 30.5772 39.91 32.6665 37.3327 32.6665H18.666C16.0887 32.6665 13.9993 30.5772 13.9993 27.9998Z"
      stroke="var(--sf-base-icon-primary)"
      stroke-width="2"
    />
  </svg>
</template>
